module.exports = __webpack_public_path__ + "static/media/3_r_traktor_75.68_76.3.f87d03ad.png";